import { createModuleLogger } from '#apps/client-web/app/services/logger';
import { type AppSettings } from '#apps/client-web/features/settings/models/app-settings';
import { LocalForageKeyValueRepo } from '#apps/client-web/app/repositories/local-forage-kv-repo';
import { LocalForageDbService } from '#apps/client-web/app/services/local-forage-db';

import { SettingsService } from './settings';

const logger = createModuleLogger('settings-service');

export const settingsDatabase = LocalForageDbService.createInstance('settings');

export const settingsRepo = new LocalForageKeyValueRepo({
  db: settingsDatabase,
  logger,
});

export const appSettingsService = new SettingsService<AppSettings>({
  key: 'app',
  repo: settingsRepo,
  logger,
});

export type AppSettingsService = SettingsService<AppSettings>;
